"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplitudeCookie = void 0;
/**
 * This class provides utility functions for parsing and handling identity
 * from Amplitude cookies.
 */
class AmplitudeCookie {
    /**
     * @param amplitudeApiKey The Amplitude API Key
     * @returns The cookie name that Amplitude sets for the provided
     * Amplitude API Key
     */
    static cookieName(amplitudeApiKey) {
        if ((amplitudeApiKey === null || amplitudeApiKey === void 0 ? void 0 : amplitudeApiKey.length) < 6) {
            throw Error('Invalid Amplitude API Key');
        }
        return 'amp_' + amplitudeApiKey.substring(0, 6);
    }
    /**
     * @param amplitudeCookie A string from the amplitude cookie
     * @returns a ExperimentUser context containing a device_id and user_id
     * (if available)
     */
    static parse(amplitudeCookie) {
        const values = amplitudeCookie.split('.');
        let user_id = undefined;
        if (values[1]) {
            try {
                user_id = Buffer.from(values[1], 'base64').toString('utf-8');
            }
            catch (e) {
                user_id = undefined;
            }
        }
        return {
            device_id: values[0],
            user_id,
        };
    }
    /**
     * Generates a cookie string to set for the Amplitude Javascript SDK
     * @param deviceId A device id to set
     * @returns A cookie string to set for the Amplitude Javascript SDK to read
     */
    static generate(deviceId) {
        return deviceId + '..........';
    }
}
exports.AmplitudeCookie = AmplitudeCookie;
